<template>
  <div class="mt-5">
    <!-- <c-call-us
      background="bg-secondary text-center py-3 font-weight-bold text-white lead"
      astyle="text-white"
    /> -->
    <div class="bg-dark text-white">
      <div class="pt-3">
        <div class="container-fluid px-5">
          <div class="row">
            <div class="col-md-6 pb-4">
              <!-- <img
                src="../assets/img/elsolution.jpg"
                alt="elsolution"
                class="img-fluid"
              /> -->
              <div v-if="constants.links" class="small">
                <h2>Web</h2>
                <div v-for="(x, idx) in constants.links" :key="idx">
                  <a :href="'https://www.' + x.domain" :title="x.title">{{ x.domain }}</a>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <c-contact />
            </div>
            <!-- <div class="col-md-5">
              <c-contact-form />
            </div> -->
          </div>
        </div>
      </div>
      <footer class="container-fluid">
        <div class="text-center">
          <span class="small"
            >Copyright © {{ year }} {{ constants.appName }} | Izrada web
            stranice:
            <a
              href="https://www.igprog.hr"
              title="Izrada web stranica i aplikacija"
              class="font-weight-bold"
              >IG PROG</a
            ></span
          >
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
import cContact from "./cContact.vue";
import cContactForm from "./cContactForm.vue";
import cCallUs from "./cCallUs.vue";
export default {
  components: {
    cContact,
    cContactForm,
    cCallUs,
  },
  data() {
    return {
      year: new Date().getFullYear(),
      constants: this.$constants,
    };
  },
};
</script>

<style scoped>
a {
  color: #fff !important;
}
</style>


// WEBPACK FOOTER //
// src/components/cFooter.vue